export default {
    path: '/task/taskAdd',
    name: 'TaskAdd',
    component: () => import(/* webpackChunkName: "taskAdd" */ '../../views/task/components/taskAdd.vue')
}